/* eslint-disable import/no-default-export */
import CoachmarkTooltip from './components/CoachmarkTooltip';

export default CoachmarkTooltip;
